export const userLogsConstants = {
  GET_USERS_REQUEST: 'GET_USERS_REQUEST',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  GET_USERS_FAILURE: 'GET_USERS_FAILURE',
  GET_USER_LOGS_REQUEST: 'GET_USER_LOGS_REQUEST', 
  GET_USER_LOGS_SUCCESS: 'GET_USER_LOGS_SUCCESS',
  GET_USER_LOGS_FAILURE: 'GET_USER_LOGS_FAILURE',
}